export default __webpack_public_path__ + "static/media/logo-white.71d9f2ff.svg";